// src/components/Sidebar.js
import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css"; // Optional: for styling

export default function Sidebar() {
  return (
    <div className="sidebar">
      <h3>📂 Menu</h3>
      
      <NavLink to="/" className="sidebar-link">
        🏠 Home
      </NavLink>

      <NavLink to="/about" className="sidebar-link">
        ℹ️ About
      </NavLink>

      <NavLink to="/contact" className="sidebar-link">
        📞 Contact
      </NavLink>

      <NavLink to="/user" className="sidebar-link">
        👤 User
      </NavLink>

      <NavLink to="/uploadcsv" className="sidebar-link">
        📤 Upload CSV
      </NavLink>
      <NavLink to="/plp-url-change" className="sidebar-link">
        PLP 
      </NavLink>
      <NavLink to="/innovid" className="sidebar-link">
        INNOVID 
      </NavLink>
      
    </div>
  );
}
